import { createSlice } from '@reduxjs/toolkit'
import {
  getLandingUrlDto,
  getLandingUrlState,
} from 'features/creative/creativeUtil'
import { validateLandingUrlWithSiteUrl } from 'features/creative/add/common/useCreativeValidation'

const initialState = {
  images: [
    {
      id: '',
      url: '',
      name: '',
      size: 0,
      w: 0,
      h: 0,
      alt: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      id: '',
      url: '',
      name: '',
      size: 0,
      w: 0,
      h: 0,
      alt: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
    {
      id: '',
      url: '',
      name: '',
      size: 0,
      w: 0,
      h: 0,
      alt: '',
      landingUrl: {
        individual: false,
        mobileUrl: '',
        pcUrl: '',
      },
    },
  ],
}

export const validateMultiThumbnail = (active, state, siteUrl) => ({
  images: state.images.map(({ url, alt, landingUrl }) => ({
    url: active && url === '' && '이미지를 등록하세요.',
    alt: active && alt === '' && '내용을 입력하세요.',
    landingUrl: {
      ...(active && validateLandingUrlWithSiteUrl(landingUrl, siteUrl)),
    },
  })),
})

export const getMultiThumbnailAssetData = state => ({
  type: 'MULTI_THUMBNAIL',
  data: {
    images: state.images.map(image => ({
      ...image,
      landingUrl: getLandingUrlDto(image.landingUrl),
    })),
  },
})

const multiThumbnailSlice = createSlice({
  name: 'multiThumbnail',
  initialState,
  reducers: {
    reset: () => initialState,
    setAlt: (state, { payload: { index, alt } }) => {
      state.images[index].alt = alt
    },
    setAllIndividual: (state, { payload: individual }) => {
      state.images.forEach(image => {
        image.landingUrl.individual = individual
      })
    },
    setIndividual: (state, { payload: { index, checked } }) => {
      state.images[index].landingUrl.individual = checked
    },
    setMobileUrl: (state, { payload: { index, url } }) => {
      state.images[index].landingUrl.mobileUrl = url
    },
    setPcUrl: (state, { payload: { index, url } }) => {
      state.images[index].landingUrl.pcUrl = url
    },
    setMultiThumbnail: (state, { payload: { images } }) => {
      images.forEach((image, index) => {
        state.images[index] = {
          ...image,
          landingUrl: getLandingUrlState(image.landingUrl),
          isUploading: false,
          isUploaded: true,
        }
      })
    },
    setMultiThumbnailId: (state, { payload: { dspImageDtos } }) => {
      state.images.forEach(image => {
        const dspImage = dspImageDtos.find(({ url }) => url === image.url)
        if (dspImage) {
          image.id = dspImage.id
        }
      })
    },
    setImage: (state, { payload: { index, image } }) => {
      const { id, url, width, height, name, size } = image
      state.images[index] = {
        ...state.images[index],
        id,
        url,
        name,
        size,
        w: width,
        h: height,
      }
    },
    resetImage: (state, { payload: { index } }) => {
      state.images[index] = {
        ...state.images[index],
        id: '',
        url: '',
        name: '',
        size: 0,
        w: 0,
        h: 0,
      }
    },
  },
})

export const {
  reset,
  setPcUrl,
  setMobileUrl,
  setAllIndividual,
  setIndividual,
  setAlt,
  setImage,
  resetImage,
  setMultiThumbnail,
  setMultiThumbnailId,
} = multiThumbnailSlice.actions

export default multiThumbnailSlice.reducer
